// extracted by mini-css-extract-plugin
module.exports = {"input_wrapper":"inputswrapper_input_wrapper__1x0na","col":"inputswrapper_col__32sxN","input_label__leading":"inputswrapper_input_label__leading__1hYge"};